module.exports = [{"code":"H","name":"货车"},{"code":"H10","name":"重型货车"},{"code":"H20","name":"中型货车"},{"code":"H30","name":"轻型货车"},{"code":"H41","name":"皮卡车"},{"code":"K","name":"客车"},{"code":"K10","name":"大型客车"},{"code":"K20","name":"面包车"},{"code":"K31","name":"微型面包车"},{"code":"K27","name":"商务车"},{"code":"K32","name":"越野车"},{"code":"K33","name":"小型轿车"},{"code":"Q","name":"其他"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/vehicleClassType.json
// module id = 5lVH
// module chunks = 11